/**
 * @generated SignedSource<<b4e6bf24f9aa6423b4d0361f8f7bb380>>
 * @relayHash 13aa49e5af28c01b6b6762601e9476c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 851580cb9d951c93b82ad6c736b6220e50b3e4d3dc4fdc83615ae0c813955c29

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type JiraProjectOptions = {
  projectType?: JiraProjectType | null | undefined;
};
export type getProjectProps_recentlyUsedProjectsQuery$variables = {
  cloudId: string;
  projectOptions?: JiraProjectOptions | null | undefined;
};
export type getProjectProps_recentlyUsedProjectsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly recentlyUsedProjects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly project: {
              readonly avatar: {
                readonly small: string | null | undefined;
              } | null | undefined;
            };
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getProjectProps_recentlyUsedProjectsQuery = {
  response: getProjectProps_recentlyUsedProjectsQuery$data;
  variables: getProjectProps_recentlyUsedProjectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectOptions"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "projectOptions",
    "variableName": "projectOptions"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v5 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getProjectProps_recentlyUsedProjectsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "concreteType": "JiraJqlProjectFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "recentlyUsedProjects",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraJqlProjectFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraJqlProjectFieldValue",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v4/*: any*/),
                            {
                              "concreteType": "JiraProject",
                              "kind": "LinkedField",
                              "name": "project",
                              "plural": false,
                              "selections": [
                                (v5/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getProjectProps_recentlyUsedProjectsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraJqlProjectFieldValueConnection",
                "kind": "LinkedField",
                "name": "recentlyUsedProjects",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraJqlProjectFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraJqlProjectFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "851580cb9d951c93b82ad6c736b6220e50b3e4d3dc4fdc83615ae0c813955c29",
    "metadata": {},
    "name": "getProjectProps_recentlyUsedProjectsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ccf1cae43528843cd934c1484f140c93";

export default node;
